/** @format */
// 创建、修改事件告警Drawer
import React, { FC, useEffect, useState, useRef } from 'react'
import { _$, Drawer, Form, FormItem, Input, Select, Option, Message, Radio } from 'kpc-react'
import styled from 'styled-components'
import API from 'src/api/ApiEventCenter'
import SelectInstance from 'src/components/SelectInstance'
import EventDialog from './EventDialog'
import AlarmReciver from 'src/components/AlarmReciver'
import AlarmCallBack from 'src/components/AlarmCallBack'
import AlarmCallBackTooltip from 'src/components/AlarmCallBack/Tooltip'
import SelectTemplate from 'src/containers/MonitorAlarmTemplate/SelectTemplate'
import { CreateAlarmDrawerProps, CreateFormValuesProps, createFormValueInit } from './constants'
import { EventOptions, eventListToOptions } from 'src/pages/EventCenter/constants'
import { request } from 'src/utils'
import _ from 'lodash'
import Cookies from 'js-cookie'

const lange = Cookies.get('ksc_lang')
const CreateAlarmDrawer: FC<CreateAlarmDrawerProps> = ({
  className,
  visible,
  setVisible,
  submitCallback,
  eventList,
  defaultValues
}) => {
  const [eventListState, setEventListState] = useState<any[]>([])
  const [eventOptions, setEventOptions] = useState<EventOptions[]>([])
  // 触发条件
  const [trigger, setTrigger] = useState<'rule' | 'template'>('rule')
  // 告警模版
  const [template, setTemplate] = useState<any>(undefined)
  const [formValues, setFormValues] = useState<CreateFormValuesProps>(createFormValueInit)
  const [projectFlag, setProjectFlag] = useState<boolean>(false)
  const contactRef = useRef<any>()
  const callbackRef = useRef<any>()
  const formRef = useRef<any>()

  // 初始化创建默认值
  useEffect(() => {
    if (visible) {
      if (defaultValues) {
        const { PolicyName, ResourceBindType, TemplateID } = defaultValues
        if (TemplateID) {
          setTrigger('template')
          setTemplate({ TemplateID })
        }
        if (PolicyName && ResourceBindType === 3) {
          getPolictResource().then(resourceList => {
            changeFormValues({
              ...defaultValues,
              InstanceIds: resourceList || []
            })
          })
        } else {
          setFormValues({
            ...formValues,
            ...defaultValues
          })
        }
      }
      if (eventList?.length) {
        setEventListState(eventList)
        setEventOptions(eventListToOptions(eventList) as EventOptions[])
      } else {
        getEventList()
      }
    } else {
      setTrigger('rule')
      setTemplate(undefined)
      setFormValues(createFormValueInit)
    }
  }, [visible])

  // 获取事件策略关联资源
  const getPolictResource = async () => {
    const result = await request(API.getPolictResource, {
      method: 'GET',
      data: {
        PolicyName: defaultValues.PolicyName,
        pageIndex: 1
      }
    })
    if (result && result?.code === 'Success' && result?.data.resourceList) {
      return result?.data.resourceList
    } else {
      return []
    }
  }

  // 获取全部事件
  const getEventList = async () => {
    const result = await request(API.getListSysEvents, {
      data: {
        ProductType: 999
      }
    })
    if (result && result?.code === 'Success' && result?.data.eventList) {
      setEventListState(result?.data.eventList)
      setEventOptions(eventListToOptions(result?.data.eventList) as EventOptions[])
    } else {
      Message.error(result?.message)
    }
  }

  // 修改formValues
  const changeFormValues = values => {
    setFormValues({
      ...formValues,
      ...values
    })
  }

  useEffect(() => {
    const value = formValues.ProductType
    if (value !== null && eventOptions?.length) {
      const projectFlag = eventOptions.find(item => item.value === value)?.iamProjectFlag
      const updateResource =
        formValues.ResourceBindType === 2 && projectFlag !== 1 ? 3 : formValues.ResourceBindType
      changeFormValues({
        ResourceBindType: updateResource
      })
      setProjectFlag(projectFlag === 1)
    }
  }, [formValues.ProductType, eventOptions])

  // 提交
  const formSubmit = async () => {
    const validate = await formRef?.current?.validate()
    if (validate) {
      const paramsForm = _.cloneDeep(formValues)
      // 事件
      paramsForm.EventPattern = {
        EventTypes: ['*'],
        EventLevels: ['*'],
        EventNames: []
      }
      if (trigger === 'rule') {
        if (paramsForm.EventRadio === 1) {
          paramsForm.EventPattern.EventNames = ['*']
        } else if (paramsForm.EventRadio === 2) {
          paramsForm.EventPattern.EventNames = paramsForm.EventNames || []
        }
        paramsForm.TemplateID = 0
      } else if (trigger === 'template') {
        paramsForm.TemplateID = template?.TemplateID
        paramsForm.EventPattern.EventNames = template.EventPattern.EventNames
      }
      // 实例
      if (paramsForm.ResourceBindType === 3) {
        paramsForm.InstanceIds = paramsForm.InstanceIds.map(({ instanceId }) => instanceId)
      }
      delete paramsForm.EventRadio
      delete paramsForm.EventNames
      // 告警接收人
      const users = contactRef.current && contactRef.current.getRecivers()
      if (!users) return false
      paramsForm.UserNotice = users
      // 告警回调
      const callback = callbackRef.current && (await callbackRef.current.getUrl())
      if (!callback) return false
      paramsForm.UrlNotice = callback
      // 判断是修改还是创建
      const url = defaultValues.PolicyName ? API.modifyEventPolicy : API.createEventPolicy
      const result = await request(url, {
        method: 'POST',
        data: {
          ...paramsForm
        }
      })
      if (result?.code === 'Success') {
        Message.success(result?.message)
        setVisible(false)
        submitCallback && submitCallback(paramsForm)
      } else {
        Message.error(result?.message)
      }
    }
  }
  return (
    <Drawer
      value={visible}
      title={_$('创建/修改事件告警策略')}
      ok={formSubmit}
      on$change-value={(c, showDrawer) => {
        setVisible(showDrawer)
      }}
      className="custom-alarm-drawer"
    >
      <div className={className}>
        <Form starOnRequired={true} ref={formRef} labelWidth={lange === 'en' ? 120 : 100}>
          <p className="card-title">{_$('基本信息')}</p>
          <FormItem label={_$('策略名称')} value={formValues.PolicyName} rules={{ required: true }}>
            <Input
              value={formValues.PolicyName}
              disabled={!!defaultValues?.PolicyName}
              onChange={e => {
                changeFormValues({
                  PolicyName: e.target.value
                })
              }}
            />
          </FormItem>
          <FormItem label={_$('描述')} value={formValues.PolicyDesc}>
            <Input
              value={formValues.PolicyDesc}
              onChange={e => {
                changeFormValues({
                  PolicyDesc: e.target.value
                })
              }}
            />
          </FormItem>
          <p className="card-title">{_$('告警规则')}</p>
          <FormItem
            label={_$('产品类型')}
            value={formValues.ProductType}
            rules={{ required: true }}
          >
            <Select
              value={formValues.ProductType}
              placeholder={_$('请选择产品类型')}
              disabled={defaultValues?.ProductType !== undefined}
              onChange={value => {
                changeFormValues({
                  ProductType: value
                })
                setTemplate(undefined)
              }}
            >
              {eventOptions?.length &&
                eventOptions.map(({ label, value }) => (
                  <Option key={value} value={value}>
                    {_$(label)}
                  </Option>
                ))}
            </Select>
          </FormItem>
          {formValues.ProductType !== undefined ? (
            <>
              <FormItem
                label={_$('触发条件')}
                value={trigger}
                rules={{ required: true }}
                messages={{
                  required: _$('请选择触发条件')
                }}
              >
                <Radio
                  name="trigger"
                  trueValue="template"
                  value={trigger}
                  on$change-value={(c, value) => setTrigger(value)}
                >
                  选择模版
                </Radio>
                <Radio
                  name="trigger"
                  trueValue="rule"
                  value={trigger}
                  on$change-value={(c, value) => setTrigger(value)}
                >
                  手动匹配
                </Radio>
              </FormItem>
              {trigger === 'template' ? (
                <SelectTemplate
                  type="event"
                  value={template?.TemplateID}
                  productType={parseFloat(formValues.ProductType)}
                  eventList={eventListState}
                  onChange={value => {
                    setTemplate(value)
                  }}
                />
              ) : null}
              {trigger === 'rule' ? (
                <FormItem
                  label={_$('事件名称')}
                  value={formValues.EventRadio}
                  rules={{
                    required: true,
                    checkIns(value) {
                      const { EventNames } = formValues
                      if (value === 2 && !EventNames?.length) {
                        return _$('自选事件不能为空')
                      } else {
                        return true
                      }
                    }
                  }}
                >
                  <EventDialog
                    productType={formValues.ProductType}
                    eventList={eventListState}
                    defaultRadio={formValues?.EventRadio || 1}
                    defaultValue={formValues?.EventNames || []}
                    onChange={(radio, EventNames) => {
                      changeFormValues({
                        EventRadio: radio,
                        EventNames
                      })
                    }}
                  />
                </FormItem>
              ) : null}
            </>
          ) : null}
          {formValues.ProductType !== undefined ? (
            <FormItem
              label={_$('关联资源')}
              value={formValues.ResourceBindType}
              rules={{
                required: true,
                checkIns(value) {
                  const { InstanceIds, ProjectId } = formValues
                  if (value === 3 && !InstanceIds?.length) {
                    return _$('请选择实例')
                  } else if (value === 2 && ProjectId === undefined) {
                    return _$('请选择项目')
                  } else {
                    return true
                  }
                }
              }}
            >
              <SelectInstance
                productType={formValues.ProductType}
                isRegionFilter={true}
                defaultRadioValue={formValues.ResourceBindType}
                defaultInstance={formValues.InstanceIds}
                projectDimens={projectFlag}
                // 127 = 已作废项目
                disabled={
                  defaultValues.ResourceBindType === 2 || defaultValues.ResourceBindType === 127
                }
                defalutProject={formValues.ProjectId}
                projectDisabled={defaultValues.ResourceBindType !== undefined}
                allInstance={false}
                instanceGroup={false}
                getSelectedInstaces={
                  defaultValues?.ResourceBindType === 2 ? getPolictResource : undefined
                }
                onChange={(radio, value) => {
                  if (radio === 1 || radio === 3) {
                    changeFormValues({
                      ResourceBindType: radio,
                      InstanceIds: value
                    })
                  } else if (radio === 2) {
                    changeFormValues({
                      ResourceBindType: radio,
                      ProjectId: value
                    })
                  }
                }}
              />
            </FormItem>
          ) : null}
          <FormItem label={_$('告警接收人')}>
            <AlarmReciver ref={contactRef} defaultValue={formValues?.UserNotice} />
          </FormItem>
          <FormItem b-label={<AlarmCallBackTooltip />}>
            <AlarmCallBack ref={callbackRef} defaultValue={formValues?.UrlNotice} />
          </FormItem>
        </Form>
      </div>
    </Drawer>
  )
}

export default styled(CreateAlarmDrawer)`
  .card-title {
    font-size: 14px;
    font-weight: 700;
    margin: 0;
    padding-bottom: 10px;
  }
  .k-radio {
    margin-right: 16px;
  }
`
